import { useEffect, useRef } from 'react';
import atlantico from "../../images/atlantico/atlantico.jpg";
import gsap from 'gsap';

export default function Atlantico() {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (sectionRef.current) {
      gsap.fromTo(sectionRef.current,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' }
      );
    }
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full h-[100vh] h-[100dvh] flex items-start justify-center overflow-hidden pt-32 md:pt-48">
      <div
        className="absolute inset-0 z-0 bg-cover bg-center md:bg-[position:right_-20%]"
        style={{
          backgroundImage: `url(${atlantico})`,
        }}
      >
        <div className="absolute inset-0" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
        <h2 className="font-custom font-bold text-mainBlue md:text-8xl text-5xl">ATLÂNTICO</h2>
      </div>
    </section>
  );
}
